import { render, staticRenderFns } from "./UpdateEvent.vue?vue&type=template&id=5f0ca8e3&scoped=true"
import script from "./UpdateEvent.vue?vue&type=script&lang=js"
export * from "./UpdateEvent.vue?vue&type=script&lang=js"
import style0 from "./UpdateEvent.vue?vue&type=style&index=0&id=5f0ca8e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ca8e3",
  null
  
)

export default component.exports